var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("g", { stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            React.createElement("path", { fill: "none", d: "M0 0h48v48H0z" }),
            React.createElement("path", { d: "M11.707 21.472L24.4 8.765a2.627 2.627 0 013.707 0l11.127 11.14a2.636 2.636 0 010 3.713l-12.74 12.754c-.654.653-1.608.927-2.488 1.086L11.98 39.966c-2.16.333-4.3-1.814-3.94-3.947l2.54-12.014c.16-.947.473-1.88 1.127-2.533zM23.362 34.81l9.254-9.248a1.31 1.31 0 000-1.853 1.318 1.318 0 00-1.85 0l-8.561 8.557a1.634 1.634 0 11-2.308-2.312l8.554-8.558a1.3 1.3 0 000-1.847 1.306 1.306 0 00-1.85 0l-8.56 8.557a1.631 1.631 0 01-2.31 0 1.636 1.636 0 010-2.311l8.556-8.558a1.31 1.31 0 00-1.85-1.853l-9.253 9.255L12 30.85 17.149 36l6.213-1.19z", fill: "currentColor", fillRule: "nonzero" }))));
});
